export function formatVoiceTestError(error, fallback, provider = '豆包') {
  const providerError = error?.response?.data?.error;
  const message =
    providerError?.provider_message ||
    providerError?.message ||
    error?.message ||
    fallback;
  const details = [];
  if (providerError?.provider_code) {
    details.push(`${provider}错误码：${providerError.provider_code}`);
  }
  if (providerError?.provider_log_id) {
    details.push(`${provider === '阿里百炼' ? 'Request ID' : 'Log ID'}：${providerError.provider_log_id}`);
  }
  return details.length ? `${message}（${details.join('，')}）` : message;
}

export function validateTTSTest({ input, speed }) {
  if (!input?.trim()) return '请输入合成文本';
  const numericSpeed = Number(speed);
  if (!Number.isFinite(numericSpeed) || numericSpeed < 0.5 || numericSpeed > 2) {
    return '语速必须在 0.5 到 2.0 之间';
  }
  return '';
}

export function validateCloneTest({
  userId,
  referenceText,
  file,
  recordingDuration = null,
}) {
  if (!userId?.trim()) return '请输入业务用户 ID';
  if (!referenceText?.trim()) return '请输入参考文本';
  if (
    recordingDuration !== null &&
    (recordingDuration < 10 || recordingDuration > 20)
  ) {
    return '录音时长必须在 10 到 20 秒之间';
  }
  if (!file) return '请选择 WAV、MP3 或 M4A 录音文件';
  if (!/\.(wav|mp3|m4a)$/i.test(file.name || '')) {
    return '声音复刻仅支持 WAV、MP3 或 M4A 文件';
  }
  return '';
}

export function isTerminalCloneStatus(status) {
  return status === 'ready' || status === 'failed';
}

export function isManagedVoiceChannel(channel) {
  return channel?.type === 49 || channel?.type === 52;
}
